<template>
  <tr class="h-40">
    <td
      :colspan="colSpan"
      class="px-6 py-12 text-center text-gray-400 border-b border-[#E2E8F0]"
    >
      <div class="flex flex-col items-center gap-2">
        <span class="text-14 font-medium">{{ message }}</span>
      </div>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    colSpan: {
      type: Number,
      default: 1
    },
    message: {
      type: String,
      default: 'Loading...'
    }
  }
}
</script>